import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { 
  Hashtags,
  AddHashtag,
  HashtagDetails,
  EditHashtag
} from '@screens';

export type HashtagsStackParamList = {
  HashtagsList: undefined;
  HashtagDetails: {
    params?: {
      hashtagId: string;
    };
    onEdit?: () => void;
  },
  AddHashtag: undefined;
  EditHashtag: {
    params: {
      hashtagId: string;
    };
    onEdit: () => void;
  };
};

const Stack = createNativeStackNavigator<HashtagsStackParamList>();

const HashtagsStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen 
        name="HashtagsList" 
        component={Hashtags} 
      />
      <Stack.Screen 
        name="HashtagDetails" 
        component={HashtagDetails} 
      />
      <Stack.Screen 
        name="AddHashtag" 
        component={AddHashtag} 
      />
      <Stack.Screen 
        name="EditHashtag" 
        component={EditHashtag} 
      />
    </Stack.Navigator>
  );
};

export default HashtagsStackNavigator; 